import React from 'react';
import { Button, Form, Input, Select } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { selectStringFilter } from '../../../utils/forms';

import './TemporadaBalancosForm.scss';

const { Option } = Select;

const companyList = [
  { value: 'RRRP3', label: '3R PETROLEUM' },
  { value: 'TTEN3', label: '3TENTOS' },
  { value: 'AGXY3', label: 'AGROGALAXY' },
  { value: 'ALOS3', label: 'ALLOS' },
  { value: 'ALPA3', label: 'ALPARGATAS' },
  { value: 'ALPA4', label: 'ALPARGATAS' },
  { value: 'ALUP11', label: 'ALUPAR' },
  { value: 'ABEV3', label: 'AMBEV' },
  { value: 'AMBP3', label: 'AMBIPAR' },
  { value: 'AMER3', label: 'AMERICANAS' },
  { value: 'ANIM3', label: 'ÂNIMA' },
  { value: 'ARZZ3', label: 'AREZZO & CO' },
  { value: 'ASAI3', label: 'ASSAI' },
  { value: 'AURE3', label: 'AUREN' },
  { value: 'AMOB3', label: 'AUTOMOB' },
  { value: 'AZUL4', label: 'AZUL' },
  { value: 'AZZA3', label: 'AZZAS 2154' },
  { value: 'B3SA3', label: 'B3' },
  { value: 'BMGB3', label: 'BANCO BMG' },
  { value: 'BBAS3', label: 'BANCO DO BRASIL' },
  { value: 'BPAN4', label: 'BANCO PAN' },
  { value: 'BRSR3', label: 'BANRISUL' },
  { value: 'BBSE3', label: 'BB SEGURIDADE' },
  { value: 'BMOB3', label: 'BEMOBI' },
  { value: 'BRBI11', label: 'BR PARTNERS' },
  { value: 'BBDC3', label: 'BRADESCO' },
  { value: 'BBDC4', label: 'BRADESCO' },
  { value: 'BRAP4', label: 'BRADESPAR' },
  { value: 'AGRO3', label: 'BRASILAGRO' },
  { value: 'BRKM5', label: 'BRASKEM' },
  { value: 'BRAV3', label: 'BRAVA ENERGIA' },
  { value: 'MBRF3', label: 'MBRF' },
  { value: 'BPAC11', label: 'BTGP BANCO' },
  { value: 'CEAB3', label: 'C&A' },
  { value: 'CXSE3', label: 'CAIXA SEGURIDADE' },
  { value: 'CAML3', label: 'CAMIL' },
  { value: 'CRFB3', label: 'CARREFOUR BR' },
  { value: 'BHIA3', label: 'CASAS BAHIA' },
  { value: 'CBAV3', label: 'CBA' },
  { value: 'CCRO3', label: 'CCR SA' },
  { value: 'CMIG4', label: 'CEMIG' },
  { value: 'CIEL3', label: 'CIELO' },
  { value: 'COGN3', label: 'COGNA ON' },
  { value: 'CSMG3', label: 'COPASA' },
  { value: 'CPLE6', label: 'COPEL' },
  { value: 'CSAN3', label: 'COSAN' },
  { value: 'CPFE3', label: 'CPFL ENERGIA' },
  { value: 'CSED3', label: 'CRUZEIRO DO SUL' },
  { value: 'CMIN3', label: 'CSN MINERAÇÃO' },
  { value: 'CSUD3', label: 'CSU DIGITAL' },
  { value: 'CURY3', label: 'CURY' },
  { value: 'CVCB3', label: 'CVC BRASIL' },
  { value: 'CYRE3', label: 'CYRELA REALT' },
  { value: 'DXCO3', label: 'DEXCO' },
  { value: 'DIRR3', label: 'DIRECIONAL' },
  { value: 'ELET3', label: 'ELETROBRAS' },
  { value: 'ELET6', label: 'ELETROBRAS' },
  { value: 'EMBR3', label: 'EMBRAER' },
  { value: 'ENGI11', label: 'ENERGISA' },
  { value: 'ENEV3', label: 'ENEVA' },
  { value: 'EGIE3', label: 'ENGIE' },
  { value: 'EQTL3', label: 'EQUATORIAL' },
  { value: 'ESPA3', label: 'ESPAÇO LASER' },
  { value: 'ETER3', label: 'ETERNIT' },
  { value: 'EVEN3', label: 'EVEN' },
  { value: 'EZTC3', label: 'EZTEC' },
  { value: 'FLRY3', label: 'FLEURY' },
  { value: 'FRAS3', label: 'FRAS-LE' },
  { value: 'GGBR4', label: 'GERDAU' },
  { value: 'GOAU4', label: 'GERDAU' },
  { value: 'GOLL4', label: 'GOL' },
  { value: 'PCAR3', label: 'GPA' },
  { value: 'GRND3', label: 'GRENDENE' },
  { value: 'GGPS3', label: 'GRUPO GPS' },
  { value: 'NTCO3', label: 'GRUPO NATURA' },
  { value: 'SOMA3', label: 'GRUPO SOMA' },
  { value: 'GUAR3', label: 'GUARARAPES' },
  { value: 'HAPV3', label: 'HAPVIDA' },
  { value: 'HBSA3', label: 'HIDROVIAS DO BRASIL' },
  { value: 'HYPE3', label: 'HYPERA' },
  { value: 'IGTI11', label: 'IGUATEMI S.A.' },
  { value: 'MYPK3', label: 'IOCHPE MAXION' },
  { value: 'IRBR3', label: 'IRBBRASIL RE' },
  { value: 'ITSA4', label: 'ITAUSA' },
  { value: 'ITUB4', label: 'ITAÚ UNIBANCO' },
  { value: 'JBSS3', label: 'JBS' },
  { value: 'JSLG11', label: 'JSL' },
  { value: 'KEPL3', label: 'KEPLER WEBER' },
  { value: 'KLBN11', label: 'KLABIN' },
  { value: 'LIGT3', label: 'LIGHT' },
  { value: 'RENT3', label: 'LOCALIZA' },
  { value: 'LOGG3', label: 'LOG COMMERCIAL PROPERTIES' },
  { value: 'LREN3', label: 'LOJAS RENNER' },
  { value: 'LWSA3', label: 'LWSA' },
  { value: 'MDIA3', label: 'M DIAS BRANCO' },
  { value: 'MGLU3', label: 'MAGAZINE LUIZA' },
  { value: 'MRFG3', label: 'MARFRIG' },
  { value: 'AMAR3', label: 'MARISA' },
  { value: 'MATD3', label: 'MATER DEI' },
  { value: 'CASH3', label: 'MÉLIUZ' },
  { value: 'MELK3', label: 'MELNICK' },
  { value: 'MILS3', label: 'MILLS' },
  { value: 'BEEF3', label: 'MINERVA' },
  { value: 'MBLY3', label: 'MOBLY' },
  { value: 'MDNE3', label: 'MOURA DUBEUX' },
  { value: 'MOVI3', label: 'MOVIDA' },
  { value: 'MRVE3', label: 'MRV' },
  { value: 'MULT3', label: 'MULTIPLAN' },
  { value: 'ODPV3', label: 'ODONTOPREV' },
  { value: 'OIBR3', label: 'OI' },
  { value: 'ONCO3', label: 'ONCOCLÍNICAS' },
  { value: 'PGMN3', label: 'PAGUE MENOS' },
  { value: 'PETR3', label: 'PETROBRAS' },
  { value: 'PETR4', label: 'PETROBRAS' },
  { value: 'RECV3', label: 'PETRORECSA' },
  { value: 'PRIO3', label: 'PETRORIO' },
  { value: 'PETZ3', label: 'PETZ' },
  { value: 'PLPL3', label: 'PLANO&PLANO' },
  { value: 'PSSA3', label: 'PORTO SEGURO' },
  { value: 'PRNR3', label: 'PRINER' },
  { value: 'RAIZ4', label: 'RAIZEN' },
  { value: 'RAPT4', label: 'RANDON' },
  { value: 'RADL3', label: 'RD SAÚDE' },
  { value: 'RDOR3', label: "REDE D'OR" },
  { value: 'RAIL3', label: 'RUMO S.A.' },
  { value: 'SBSP3', label: 'SABESP' },
  { value: 'SAPR11', label: 'SANEPAR' },
  { value: 'SANB11', label: 'SANTANDER BR' },
  { value: 'STBP3', label: 'SANTOS BRASIL' },
  { value: 'SMTO3', label: 'SÃO MARTINHO' },
  { value: 'SEQL3', label: 'SEQUOIA' },
  { value: 'SEER3', label: 'SER EDUCACIONAL' },
  { value: 'CSNA3', label: 'SID NACIONAL' },
  { value: 'SIMH3', label: 'SIMPAR' },
  { value: 'SLCE3', label: 'SLC AGRICOLA' },
  { value: 'SMFT3', label: 'SMARTFIT' },
  { value: 'SUZB3', label: 'SUZANO S.A.' },
  { value: 'TAEE11', label: 'TAESA' },
  { value: 'VIVT3', label: 'TELEFÔNICA BRASIL' },
  { value: 'TEND3', label: 'TENDA' },
  { value: 'TIMS3', label: 'TIM' },
  { value: 'TOTS3', label: 'TOTVS' },
  { value: 'TFCO4', label: 'TRACK&FIELD' },
  { value: 'TRPL4', label: 'TRAN PAULIST' },
  { value: 'UGPA3', label: 'ULTRAPAR' },
  { value: 'USIM5', label: 'USIMINAS' },
  { value: 'VALE3', label: 'VALE' },
  { value: 'VAMO3', label: 'VAMOS' },
  { value: 'VBBR3', label: 'VIBRA' },
  { value: 'VIVA3', label: 'VIVARA' },
  { value: 'VULC3', label: 'VULCABRAS' },
  { value: 'WEGE3', label: 'WEG' },
  { value: 'PORT3', label: 'WILSON SONS' },
  { value: 'YDUQ3', label: 'YDUQS PART' },
];

const TemporadaBalancosForm = () => {

  return <div className="TemporadaBalancosForm">

    <Form.Item
      name="temporada_balancos_data"
      label="Data"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Input />
    </Form.Item>

    <Form.Item name="temporada_balancos_cor_fundo" label="Cor do fundo" className="select" rules={[{ required: true }]}>
      <Select rules={[{ required: true, message: 'Campo obrigatório!' }]}>
        <Option value="amarelo">Amarelo</Option>
        <Option value="azul_claro">Azul claro</Option>
        <Option value="azul_escuro">Azul escuro</Option>
        <Option value="verde_claro">Verde claro</Option>
        <Option value="verde_escuro">Verde escuro</Option>
      </Select>
    </Form.Item>

    <h3>Balanços</h3>
    <Form.List name="temporada_balancos">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div className="line"
              key={key}
              align="baseline"
            >
              <Form.Item
                {...restField}
                name={[name, 'ticker']}
                rules={[{ required: true, message: 'Campo obrigatório!' }]}
                style={{ minWidth: 120 }}
              >
                <Select
                  rules={[{ required: true, message: 'Campo obrigatório!' }]}
                  placeholder="Companhia"
                  filterOption={selectStringFilter}
                  allowClear
                  showSearch
                  options={companyList}
                />
              </Form.Item>

              <Form.Item
                {...restField}
                name={[name, 'horario']}
                rules={[{ required: true, message: 'Campo obrigatório!' }]}
                style={{ minWidth: 120 }}
              >
                <Select rules={[{ required: true, message: 'Campo obrigatório!' }]} placeholder="Horário">
                  <Option value="antes_abertura">Antes da abertura</Option>
                  <Option value="apos_fechamento">Após o fechamento</Option>
                  <Option value="horario_confirmar">Horário a confirmar</Option>
                </Select>
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(name)} />
            </div>
          ))}


          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
              Adicionar item
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>

  </div>
};
export default TemporadaBalancosForm;